export default __webpack_public_path__ + "static/media/exemplo-foto.e8db6ce1.png";